export default "__VITE_ASSET__9dd38cc9__"